import request from '@/utils/request'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: { object: { merchantId: 1 } },
	sign: 'dafdsf'
}
// 菜品销售表
export function chefDishStatistics (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ord/web/detail/sale/sum',
		method: 'post',
		data: obj
	})
}
// 导出菜品销售表
export function chefDishStatisticsExport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ord/web/detail/sale/sum/export',
		method: 'post',
		responseType: 'blob',
		data: obj
	})
}
// 菜品领取表
export function dishGet (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ord/web/deta/sum/get',
		method: 'post',
		data: obj
	})
}
// 导出菜品领取表
export function dishGetExport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ord/web/detail/sum/get/export',
		method: 'post',
		responseType: 'blob',
		data: obj
	})
}
// 菜品配送表
export function courierDishStatistics (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ord/web/detail/delivery/list',
		method: 'post',
		data: obj
	})
}
// 导出菜品明细汇总
export function courierDishStatisticsExport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ord/web/detail/delivery/list/export',
		method: 'post',
		responseType: 'blob',
		data: obj
	})
}
// 查询订单明细列表
export function getOrderDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ord/web/detail/list',
		method: 'post',
		data: obj
	})
}
// 导出订单明细列表
export function orderDetailExport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ord/web/detail/list/export',
		method: 'post',
		responseType: 'blob',
		data: obj
	})
}
// cmt-查询菜品明细汇总
export function getdishStatistics (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ord/web/detail/sum',
		method: 'post',
		data: obj
	})
}

// 导出菜品明细汇总
export function dishStatisticsExport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ord/web/detail/sum/export',
		method: 'post',
		responseType: 'blob',
		data: obj
	})
}
// 用餐人数统计
export function getpeopleStatistics (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ord/web/getMealCount',
		method: 'post',
		data: obj
	})
}
// 导出用餐人数表
export function peopleStatisticsExport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ord/web/exportExcel',
		method: 'post',
		responseType: 'blob',
		data: obj
	})
}
// 审核退款
export function shenhetuikuan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ordInfo/app/new/web/part/refund/check',
		method: 'post',
		data: obj
	})
}

// 部分退款
export function bufentuikuan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ordInfo/app/new/web/part/refund',
		method: 'post',
		data: obj
	})
}

// 处理异常订单
export function deductionOrd (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	console.log(JSON.stringify(obj), 9844)
	return request({
		url: '/api/v1/repordcenter/error/ord/deduction',
		method: 'post',
		data: obj
	})
}
// 根据订单号核销订单
export function cancelOrder (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	console.log(JSON.stringify(obj), 9844)
	return request({
		url: '/ordInfo/write/off',
		method: 'post',
		data: obj
	})
}
// 根据订单号核销订单（报餐）
export function cancelOrderbook (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/ord/book/write/off',
		method: 'post',
		data: obj
	})
}

// 分页查询订单
export function getOrderList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ordInfo/queryPageOrdInfo',
		method: 'get',
		params: obj
	})
}
// 多元化查询审核订单
export function getShenheOrderByCon (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ordInfo/queryPageRefundOrdInfoDetail',
		method: 'post',
		data: obj
	})
}
// 多元化查询订单
export function getOutOrderByCon (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/ord/outer/consume/queryPageOrdInfoDetail',
		method: 'post',
		data: obj
	})
}

// 多元化查询订单
export function getOrderByCon (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ordInfo/queryPageOrdInfoDetail',
		method: 'post',
		data: obj
	})
}

// 根据订单号打印订单
export function printOrd (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ntcPrintInfo/printOrdId',
		method: 'post',
		data: obj
	})
}

// 访客盘消费流水表
export function getVisitorflowdetailpage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repflowdetail/visitorflowdetailpage',
		method: 'post',
		data: obj
	})
}

// 访客盘消费统计
export function getVisitorsum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repreportform/visitorsum',
		method: 'post',
		data: obj
	})
}

// 访客盘菜品销售汇总
export function getVisitormenupagem (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repdishsale/rep/dishsum/visitormenupage',
		method: 'post',
		data: obj
	})
}

// 多元化查询订单汇总
export function getReOrdDetByPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repordcenter/rep/ordcenter/ordsum/page',
		method: 'post',
		data: obj
	})
}

// 订单汇总页面
export function getOrdSum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ordInfo/rep/ordcenter/ordsum/page',
		method: 'post',
		data: obj
	})
}

// 多元化查询配送明细
export function getDeliveryDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repordcenter/rep/ordcenter/delivery/page',
		method: 'post',
		data: obj
	})
}

// 异常订单-分页查询
export function getUnusualOrd (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repordcenter/rep/ord/error',
		method: 'post',
		data: obj
	})
}

// 查询每个人每天每餐报餐明细
export function getBaocanOrd (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repordbook/ordbookdetailpage',
		method: 'post',
		data: obj
	})
}

// 统计每日菜品套餐各餐次数量
export function getBaocantimeOrd (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repordbook/ordbookmenusumpage',
		method: 'post',
		data: obj
	})
}

// 核销汇总
export function getHexiaopage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repordcenter/rep/ordcenter/writeoffordsum/page',
		method: 'post',
		data: obj
	})
}

// 订单退款(充值退款)
export function getRechargerefund (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repordcenter/rep/ordcenter/rechargerefund',
		method: 'post',
		data: obj
	})
}

// 订单退款(消费退款)
export function getOrdrefund (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repordcenter/rep/ordcenter/ordrefund',
		method: 'post',
		data: obj
	})
}

// 补扣退款记录
export function getOrdbukourefund (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/repordcenter/rep/ordcenter/supplementrefund',
		method: 'post',
		data: obj
	})
}

// 导出订单明细
export function exportOrdInfoDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ordInfo/exportOrdInfoDetail',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 预订餐明细
export function getNgOrdInfo (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ordInfo/ng/ordInfo',
		method: 'post',
		data: obj
	})
}

// 预订餐明细
export function getKsgljOrdInfo (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ordInfo/ksglj/ordInfo',
		method: 'post',
		data: obj
	})
}

// 预订单汇总
export function getKsgljOrdSum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ordInfo/ksglj/ordsum',
		method: 'post',
		data: obj
	})
}

// 预订菜品（商品）汇总
export function getKsgljGoodssum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ordInfo/ksglj/goodssum',
		method: 'post',
		data: obj
	})
}
// 打印小票
export function apiPrint (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ordInfo/app/new/print-delivery-ord-detail',
		method: 'post',
		data: obj
	})
}

// 打印小票  余额变动打印
export function apiPrintNew (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/print/acc-trade',
		method: 'post',
		data: obj
	})
}

// 打印小票  订单详情打印
export function apiPrintOrder (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/print/order',
		method: 'post',
		data: obj
	})
}
